import type { SelectedService } from "@/types/service";
import type { Sector } from "@/types/risk-analysis";

export function normalizeSectorName(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/\//g, " ")
    .replace(/[șş]i/g, "si")
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\b(si|sau)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export type ServiceWithAnnex = SelectedService & {
  annex: "I" | "II" | null;
};

export function resolveServiceAnnex(
  services: SelectedService[],
  sectors: Sector[]
): ServiceWithAnnex[] {
  return services.map((service) => {
    const matchedSector = sectors.find(
      (s) =>
        normalizeSectorName(s.nume) === normalizeSectorName(service.sector_name)
    );
    return {
      ...service,
      annex: matchedSector?.annex ?? null,
    };
  });
}

export function resolveSectorName(sectorId: string, sectors: Sector[]): string {
  const sector = sectors.find((s) => s.id === sectorId);
  return sector?.nume ?? sectorId;
}
